import { unauthorized } from '../axios';
import {
  EMPLOYEE_LOGIN,
  EMPLOYEE_REGISTER,
  EMPLOYEE_VERIFY_OTP,
  FORGOT_PASSWORD,
  LOGIN,
  REGISTER, RESEND_OTP,
  VERIFY_OTP,
} from '../service-routes';
import { EmployeeLogin, EmployeeRegister, ForgotPassoword, Login, Otp, Register } from '../constant/serviceType';


export const postLogin = (payload: Login) => {
  return unauthorized.post(LOGIN, payload);
};

export const postRegister = (payload: Register) => {
  return unauthorized.post(REGISTER, payload);
};

export const postVerifyOtp = (payload: Otp) => {
  return unauthorized.post(VERIFY_OTP, payload);
};

export const postForgottenPassword = (payload: ForgotPassoword) => {
  return unauthorized.post(FORGOT_PASSWORD, payload);
};

export const postResendOtp = (payload: ForgotPassoword) => {
  return unauthorized.post(RESEND_OTP, payload);
};

export const postEmployeeRegister = (payload: EmployeeRegister) => {
  return unauthorized.post(EMPLOYEE_REGISTER, payload);
};

export const postEmployeeVerifyOtp = (payload: Otp) => {
  return unauthorized.post(EMPLOYEE_VERIFY_OTP, payload);
};


export const postEmployeeLogin = (payload: Login) => {
  return unauthorized.post(EMPLOYEE_LOGIN, payload);
};

export const postEmployeeEmail = (payload: EmployeeLogin) => {
  return unauthorized.post(EMPLOYEE_LOGIN, payload);
};
